import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import { qrAuthState, qrAuthType } from "../../recoil/auth";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";

const InitialGuideModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  RequestNotification: any;
}) => {
  const [lang, setLang] = useRecoilState<number>(langState);
  const qrAuth = useRecoilValue<qrAuthType>(qrAuthState);
  const [pickupZone, setPickupZone] = useState<string>("");
  const [pickupZoneEn, setPickupZoneEn] = useState<string>("");
  const onCloseModal = () => {
    oProps.RequestNotification();
    oProps.setVisible(false);
  };

  // API 호출
  const getStoreInfo = async () => {
    let res = await ApiController.store.storeInfo(qrAuth.user_id);

    if (res && res.data) {
      setPickupZone(res.data.pickup_name);
      setPickupZoneEn(res.data.pickup_name_en);
    }
  };

  useEffect(() => {
    if (oProps.isVisible) getStoreInfo();
  }, [oProps.isVisible]);

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="initialGuideModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_bell.svg`}
            alt="bell"
          />
          <p>{langText.guideModal_alarm_guide[lang]}</p>

          <div>
            <div className="pickupBadge">
              <h3>
                {`${langText.arrivalModal_pickup[lang]}: ${
                  lang === 0 ? pickupZone : pickupZoneEn
                }`}
              </h3>
            </div>
            <button className="submitButton" onClick={onCloseModal}>
              {langText.guideModal_button_confirm[lang]}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default InitialGuideModal;

const Style = styled.div`
  .modal {
    padding: 25px 24px;
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  img {
    height: 40px;
  }

  h3 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: #ffffff;
  }

  .pickupBadge {
    display: inline-flex;
    justify-content: center;
    white-space: normal;
    h3 {
      max-width: 90%;
      font-size: 18px;
      line-height: 22px;
      padding: 0;
      font-weight: 500;
      color: #ffffff;
      background: #ff4a4a;
      border-radius: 50px;
      padding: 6px 20px;
    }
  }

  .submitButton {
    position: relative;
    margin-top: 16px;
    width: 100%;
    padding: 18px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
  }

  @media (max-width: 700px) {
    .modal {
      padding: 25px 14px;
      padding-top: 12%;
    }

    .submitButton {
      margin-top: 10px;
      padding: 12px 0;
      font-size: 20px;
      border-radius: 5px;
    }
  }
`;
